import React from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import intl from "react-intl-universal";

interface EventListHeaderProps {
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const EventListHeader = ({ onSelectAllClick }: EventListHeaderProps) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            // indeterminate={numSelected > 0 && numSelected < rowCount}
            // checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>
        <TableCell>{intl.get("STAT_TABLE_HEADER_ACTION")}</TableCell>
        <TableCell align="right">
          {intl.get("STAT_TABLE_HEADER_FROM")}
        </TableCell>
        <TableCell align="right">{intl.get("STAT_TABLE_HEADER_TO")}</TableCell>
        <TableCell align="right">
          {intl.get("STAT_TABLE_HEADER_RESULT")}
        </TableCell>
        <TableCell align="right">
          {intl.get("STAT_TABLE_HEADER_POSSESSION")}
        </TableCell>
        <TableCell align="right">
          {intl.get("STAT_TABLE_HEADER_TIMESTAMP")}
        </TableCell>
        <TableCell align="right">
          {intl.get("STAT_TABLE_HEADER_PLAY")}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
